import { FunctionComponent } from 'react';
import Link from '@media-ui/core/src/components/Link';
import Picture from '@media-ui/core/src/components/Picture';
import * as T from './FinishedQuiz.types';
import * as s from './FinishedQuiz.css';
const FinishedQuizItem: FunctionComponent<T.IFinishedQuizItem> = ({ main_image, name, url, onClick, }) => {
    const props: React.HTMLAttributes<HTMLDivElement> = {};
    if (onClick) {
        props.onClick = onClick;
    }
    return (<div className={s.item} {...props}>
      <Picture className={s['item-image']} objectFit="cover" source={{
            src: main_image,
        }} srcSet={[
            {
                media: '(-webkit-min-device-pixel-ratio: 2),(min-resolution: 192dpi)',
                srcSet: main_image,
            },
        ]}/>
      <div className={s['item-content']}>
        <h2 className={s['item-title']}>{name}</h2>

        <Link className={s['item-more']} holder href={url} target="_blank" rel="noreferrer">
          Подробнее &rarr;
        </Link>
      </div>
    </div>);
};
export default FinishedQuizItem;
